export default __webpack_public_path__ + "static/media/price.db70d08b.jpg";